import componentsOverrides from 'src/configs/styles/overrides'

import { ThemeType } from '../ui.types'

export const idgColors = {
  primary: [
    '#D4DBFF',
    '#B5C2FF',
    '#92A4FF',
    '#7D92FF',
    '#6980FF',
    '#516DFF',
    '#3C5BFF',
    '#2649FF',
    '#1E3BE6',
    '#1730CC',
  ],
  blue: [
    '#D4DBFF',
    '#B5C2FF',
    '#92A4FF',
    '#7D92FF',
    '#6980FF',
    '#516DFF',
    '#3C5BFF',
    '#2649FF',
    '#e1e6ff',
    '#A8B6FF',
  ],
  darkBlue: [
    '#D4E0FB',
    '#BAC9E9',
    '#A1B4DD',
    '#8DA2D1',
    '#7A90C0',
    '#667EAE',
    '#566C9C',
    '#062440',
    '#364971',
    '#031331',
  ],
  red: [
    '#FFE8E8',
    '#FFDADA',
    '#FFCCCC',
    '#FFBEBE',
    '#FFB0B0',
    '#FFA2A2',
    '#E53E3E',
    '#FF9494',
    '#ebb9b9',
    '#E34A30',
  ],
  green: [
    '#CCF7E0',
    '#B3F4D1',
    '#99F1C2',
    '#80EEB3',
    '#66EBA4',
    '#4DE895',
    '#33E586',
    '#00b365',
    '#00D564',
    '#1DC39A',
  ],
  orange: [
    '#FFF1E0',
    '#FFE3C2',
    '#FFD5A3',
    '#FFC785',
    '#F7B055',
    '#E6A34F',
    '#D49649',
    '#D76A27',
    '#B07C3D',
    '#9E6F37',
  ],
  gray: [
    '#FCFDFF',
    '#F4F4F4',
    '#E6E8EC',
    '#D4D7DE',
    '#C3CBDD',
    '#8A909E',
    '#BBC2D3',
    '#A3AAB8',
    '#444955',
    '#21252C',
    '#EAECF0',
  ],
}

export const idgCssVariables = {
  'black-color': '#000000',
  'white-color': '#FFFFFF',

  'blue-50-color': '#2649FF',
  'blue-40-color': '#3C5BFF',
  'blue-30-color': '#516DFF',
  'blue-20-color': '#7D92FF',
  'blue-10-color': '#92A4FF',
  'blue-00-color': '#D4DBFF',

  'dark-blue-50-color': '#031331',
  'dark-blue-40-color': '#364971',
  'dark-blue-30-color': '#566C9C',
  'dark-blue-20-color': '#7A90C0',
  'dark-blue-10-color': '#A1B4DD',
  'dark-blue-00-color': '#D4E0FB',

  'red-50-color': '#E53E3E',
  'red-00-color': '#EBB9B9',

  'green-50-color': '#00D564',
  'green-00-color': '#CCF7E0',

  'orange-50-color': '#F7B055',
  'orange-00-color': '#F7B05533',

  'gray-60-color': '#21252C',
  'gray-50-color': '#444955',
  'gray-40-color': '#8A909E',
  'gray-30-color': '#BBC2D3',
  'gray-20-color': '#C3CBDD',
  'gray-10-color': '#F4F4F4',
  'gray-00-color': '#FCFDFF',
  'gray-light-border-color': 'rgba(102, 102, 102, 0.08)',

  'status-gray-color': '#C3CBDD',
  'status-orange-color': '#F7B055',
  'status-red-color': '#E34A30',
  'status-green-color': '#1DC39A',
  'status-blue-color': '#63b9ff',

  'status-blue-background-color': 'rgba(212, 219, 255, 0.7)',
  'status-light-blue-background-color': 'rgba(212, 219, 255, 0.3)',
  'status-orange-background-color': 'rgba(247, 176, 85, 0.2)',
  'red-00-color-opacity': '#EBB9B9B2',
  'status-green-background-color': '#ccf7e0',
  'status-red-background-color': '#ebb9b9',

  'body-color': 'var(--dark-blue-50-color)',
  'button-border-radius': '8px',
  'input-border-radius': '8px',
  'input-border-width': '2px',

  'primary-40-color': '#0D352B',
  'primary-30-color': '#0F4033',
  'primary-20-color': '#376055',
  'primary-10-color': '#5F8077',
  'primary-00-color': '#87A099',
  'secondary-40-color': '#C25F3F',
  'secondary-30-color': '#E9724C',
  'secondary-20-color': '#ED8A6A',
  'secondary-10-color': '#F0A188',
  'secondary-00-color': '#F4B9A6',
  'neutral-40-color': '#444955',
  'neutral-30-color': '#666666',
  'neutral-20-color': '#8A909E',
  'neutral-10-color': '#C3CBDD',
  'neutral-00-color': '#FCFCFF',
  'background-primary-color': '#F2F3F3',
  'background-secondary-color': '#D6F5ED',
  'neutral-10-color-opacity': 'rgba(195, 203, 221, 0.3)',
  'primary-00-color-opacity': 'rgba(135, 160, 153, 0.3)',
  'secondary-00-color-opacity': 'rgba(244, 185, 166, 0.3)',
}

export const idgMantineConfig = {
  primaryColor: 'blue',
  primaryShade: { light: 5, dark: 7 },
  fontFamily: '"SFProText", sans-serif',
  defaultRadius: 'sm',
  radius: {
    six: '6px',
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '2rem',
    xl: '3rem',
  },
  white: '#FFFFFF',
  black: '#000000',
  headings: {
    fontFamily: '"SFProText", sans-serif',
  },
}

export const idgThemeConfig = {
  name: ThemeType.IDG,
  type: 'default-360',
  version: '1.0.0',
  colors: idgColors,
  cssVariables: idgCssVariables,
  components: { ...componentsOverrides },
  mantineConfig: idgMantineConfig,
}
